(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cell", [], factory);
	else if(typeof exports === 'object')
		exports["cell"] = factory();
	else
		root["cell"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 